import React, { useCallback, useState } from 'react'

import { useProviders } from 'shared/hooks/data/provider'
import { Button } from 'shared/ui/button/Button'
import { Icon } from 'shared/ui/icon/Icon'
import { Table, TableBody, TableColumn, TableHeader, TablePaginator, TableRow } from 'shared/ui/table'
import { parseAddress } from 'shared/util/google-maps'

import classes from './ProviderListTable.module.scss'

interface ProviderListTableProps {
  className?: string
  filter?: { [key: string]: any }
}

export const ProviderListTable: React.FC<ProviderListTableProps> = ({ className, filter }) => {
  const [meta, setMeta] = useState<Http.ResponseMeta>()
  const [paging, setPaging] = useState<Http.Pagination>({ page: 1, length: 100 })
  const handleMeta = useCallback(meta => setMeta(meta), [])
  const providers = useProviders(filter, paging, handleMeta)
  return (
    <Table className={className} hover strip>
      <TableHeader>
        <TableColumn name="id" align="center">
          ID
        </TableColumn>
        <TableColumn name="name" align="flex-start" size={2}>
          Nome
        </TableColumn>
        <TableColumn name="city" align="center" size={2}>
          Cidade
        </TableColumn>
        <TableColumn name="address" align="center" size={3}>
          Endereço
        </TableColumn>
        <TableColumn name="email" align="center" size={2}>
          E-mail
        </TableColumn>
        <TableColumn name="phone" align="center">
          Telefone
        </TableColumn>
      </TableHeader>
      <TableBody>
        {providers?.map(provider => {
          const address = parseAddress(provider.address?.address_components)
          return (
            <TableRow key={provider.id}>
              <TableColumn align="center">
                <Button className={classes.id} size="sm" to={`/providers/${provider.id}`}>
                  <span>{provider.id}</span>
                  <Icon.AngleRight />
                </Button>
              </TableColumn>
              <TableColumn align="flex-start" size={2}>
                {provider.name}
              </TableColumn>
              <TableColumn align="center" size={2}>
                {address.get('city')}
                {address.has('state') && `, ${address.get('state')}`}
              </TableColumn>
              <TableColumn align="center" size={3}>
                <div>
                  {address.get('street')}
                  {address.has('number') && `, ${address.get('number')}`}
                </div>
                {address.has('neighborhood') && <div>{address.get('neighborhood')}</div>}
              </TableColumn>
              <TableColumn align="center" size={2}>
                {provider.email || '-'}
              </TableColumn>
              <TableColumn align="center">{provider.phone || '-'}</TableColumn>
            </TableRow>
          )
        })}
      </TableBody>
      <TablePaginator meta={meta} onChange={(page, length) => setPaging({ page, length })} />
    </Table>
  )
}
